"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductNameHeader = void 0;

var _styles = require("./styles");

var _index = require("../../atoms/ScreenHeader/index");

var _index2 = require("../../atoms/Status/index");

var _index3 = require("../../atoms/ProgressBar/index");

var _index4 = require("../../atoms/PriorityFlag/index");

var _index5 = require("../../atoms/ObservationFlag/index");

var _jsxRuntime = require("react/jsx-runtime");

var ProductNameHeader = function ProductNameHeader(_ref) {
  var productName = _ref.productName,
      statusType = _ref.statusType,
      priority = _ref.priority,
      date = _ref.date,
      percentRequired = _ref.percentRequired,
      productObservation = _ref.productObservation,
      dataProduct = _ref.dataProduct,
      isObservationVisible = _ref.isObservationVisible,
      toggleObservation = _ref.toggleObservation,
      hideObservation = _ref.hideObservation;
  var typeFlag = productObservation !== null && productObservation !== "" ? "high" : "low";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScreenHeader, {
      headerType: "product-name-header",
      text: productName
    }), statusType && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Status, {
      statusType: statusType
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.ProgressBar, {
      percent: percentRequired,
      progressBarType: statusType,
      percentRequired: percentRequired
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index5.ObservationFlag, {
      observation: typeFlag,
      contentObservation: productObservation,
      dataProduct: dataProduct,
      isObservationVisible: isObservationVisible,
      toggleObservation: toggleObservation // handleClickOutside = {handleClickOutside}
      ,
      hideObservation: hideObservation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScreenHeader, {
      headerType: "date-header",
      text: date
    })]
  });
};

exports.ProductNameHeader = ProductNameHeader;